class CartRemove extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this._handleRemove.bind(this));
  }

  async _handleRemove(event) {
    const removeButton = event.target.closest('[data-action="remove-item"]');
    if (!removeButton) return;
    
    event.preventDefault();
    event.stopPropagation();

    const lineItem = removeButton.closest('[data-line-item]');
    const key = removeButton.dataset.key;
    
    if (!key) {
      console.error('Missing key for cart item');
      return;
    }

    const loader = lineItem.querySelector('.line-item__loader');
    if (loader) {
      loader.hidden = false;
      loader.firstElementChild.hidden = false;
      loader.lastElementChild.hidden = true;
    }

    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          updates: {
            [key]: 0
          } 
        })
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const cartContent = await response.json();

      // Animate removal
      if (lineItem) {
        await lineItem.animate(
          { opacity: [1, 0], height: [`${lineItem.clientHeight}px`, 0] },
          { duration: 300, easing: 'ease' }
        ).finished;
        lineItem.remove();
      }

      // Update cart count and totals
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:updated', {
          bubbles: true,
          detail: { cart: cartContent }
        })
      );

      // Refresh page if cart is empty
      if (cartContent.item_count === 0) {
        window.location.reload();
        return;
      }

      // Update cart totals
      this._updateCartTotals(cartContent);

    } catch (error) {
      console.error('Error:', error);
    } finally {
      if (loader) {
        loader.hidden = true;
      }
    }
  }

  _updateCartTotals(cartContent) {
    // Update cart subtotal
    const subtotalElement = document.querySelector('[data-cart-subtotal]');
    if (subtotalElement && cartContent.total_price !== undefined) {
      subtotalElement.innerHTML = this._formatMoney(cartContent.total_price);
    }

    // Update cart total with proper currency formatting
    const totalElement = document.querySelector('.cart__total-container .heading:last-child');
    if (totalElement && cartContent.total_price !== undefined) {
      // Get the current currency from existing element
      const currentText = totalElement.textContent;
      const currencyMatch = currentText.match(/[^\d\s.,]+$/);
      const currentCurrency = currencyMatch ? currencyMatch[0].trim() : '';
      
      // Format new price with current currency
      const newPrice = this._formatMoney(cartContent.total_price);
      // Update with new price but keep current currency
      totalElement.innerHTML = newPrice + (currentCurrency ? ' ' + currentCurrency : '');
    }

    // Update cart count
    const cartCountElement = document.querySelector('cart-count');
    if (cartCountElement) {
      cartCountElement.innerText = cartContent.item_count;
    }
  }

  _formatMoney(cents) {
    if (typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, window.theme.moneyFormat || "${{amount}}");
    }
    return (cents/100).toFixed(2);
  }
}

customElements.define('cart-remove', CartRemove); 